import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
    body {
        margin: 80px 0 0 0;
        padding: 0;
        width: 100%;
        min-height: 100vh;
        background-color: #F5F5F5;
        font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
    }
`